import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const PEM = () => {
    const accordionContent = [
        <div key="1" className="p-4">
            <p>Entrepreneurial perspective: Foundation, Nature and development ofentrepreneurship, importance of
                entrepreneurs,Entrepreneurial Mind, Individual entrepreneur Typesof entrepreneurs, Entrepreneurship in
                India</p>
        </div>,
        <div key="2" className="p-4">
            <p>Beginning Considerations: Creativity and developing business ideas; Creatingand starting the venture;
                Building a competitiveadvantage; Opportunity recognition, Opportunityassessment; Legal issues</p>
        </div>,
        <div key="3" className="p-4">
            <p>Developing Financial Plans: Sources of Funds,Managing Cash Flow,Creating a successful Financial
                PlanDeveloping a business plan</p>
        </div>,
        <div key="4" className="p-4">
            <p>Developing Marketing Plans: Developing a powerful Marketing Plan, E-commerce,Integrated Marketing
                Communications
                Leading Considerations: Developing Team, Inviting candidates to join team,Leadership model</p>
        </div>
    ];

    const tabData = [
        {
            id: 'syllabus',
            label: 'Syllabus',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'notes',
            label: 'Notes',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'important',
            label: 'Important Questions',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'books',
            label: 'Books',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'PYQ',
            label: 'PYQ',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'youtube_playlist',
            label: 'Video Lectures',
            content: null, // Will be replaced in SubjectPage
        },
    ];

    return (
        <SubjectPage
            subjectName="Principles of Entrepreneurship Mindset"
            subjectKey="PEM"
            accordionContent={accordionContent}
            tabData={tabData}
            adminEmail="snaped4338@gmail.com"
            firestoreCollections={{
                notes: 'PEMNotes',
                videos: 'PEMVideos'
            }}
        />
    );
};

export default PEM;